import { create } from "zustand";

import type { AdminRole, AdminUser, Session } from "@/types/auth";

function normalizeRole(role: string) {
  return role.trim().toUpperCase();
}

export interface AuthState {
  user: AdminUser | null;
  session: Session | null;
  isLoading: boolean;
  setSession: (payload: { user: AdminUser; session: Session }) => void;
  clearSession: () => void;
  setLoading: (value: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  session: null,
  isLoading: true,
  setSession: ({ user, session }) => set({ user, session }),
  clearSession: () => set({ user: null, session: null }),
  setLoading: (value) => set({ isLoading: value }),
}));

export function hasRequiredRole(
  currentRole: AdminRole | undefined,
  requiredRole: AdminRole,
  roles: string[] = [],
) {
  if (requiredRole !== "admin") return false;
  if (currentRole === "admin") return true;
  return roles.some((role) => {
    const normalized = normalizeRole(role);
    return normalized === "ADMIN" || normalized === "USER_ROLE_ADMIN";
  });
}
